//IOT管理
export default [
	{
		path: 'iotAdministration',
		name: 'iotAdministration',
		meta: {
			title: 'IOT管理',
			icon: 'iotAdministration'
		},
		hidden: false,
		component: () => import("@/views/research/iotAdministration/index.vue"),
		children: [{
			path: 'onlineEquipment',
			name: 'onlineEquipment',
			meta: {
				title: '在线设备',
				icon: 'onlineEquipment'
			},
			hidden: false,
			component: () => import("@/views/research/iotAdministration/onlineEquipment.vue"),
		}, {
			path: 'messageInstruction',
			name: 'messageInstruction',
			meta: {
				title: '报文指令',
				icon: 'messageInstruction'
			},
			hidden: false,
			component: () => import("@/views/research/iotAdministration/messageInstruction.vue"),
		}]
	}

]